import {
  start,
  initGlobalState,
  MicroAppStateActions,
} from 'qiankun';

import { OrgType } from '@/types';
import { CurrentTenantInfo } from '@/api/modules/tenant';

type State = {
  currentOrgInfo: OrgType,
  currentOrgInfoList: OrgType[],
  currentOrgIds: string[],
  // 权限编码前缀（从租户 expandInfo.appCode 获取）
  fmPermissionPrefix: string,
  fcPermissionPrefix: string,
  // 当前租户信息（同步到子应用）
  currentTenant: CurrentTenantInfo | null,
}

// 注册微应用通信示例
const initialState: State = {
  currentOrgInfo: {} as OrgType, // 当前选中的组织架构，和微应用通信
  currentOrgInfoList: [],
  currentOrgIds: [],
  fmPermissionPrefix: 'FM_C4YUNJ_', // 默认值
  fcPermissionPrefix: 'FC_C4YUNJ_', // 默认值
  currentTenant: null, // 当前租户信息
};
const actions: MicroAppStateActions = initGlobalState(initialState);

export {
  start, // 导出 qiankun 的启动函数
  actions, // 导出通信示例
};
